import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Research from "./pages/Research";
import Performance from "./pages/Performance";
import Partners from "./pages/Partners";
// Temporarily disabled: import WhatsNext from "./pages/WhatsNext";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
// Temporarily disabled: import TradingPhilosophy from "./pages/TradingPhilosophy";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerRequest from "./pages/PartnerRequest";
import PartnerDashboard from "./pages/PartnerDashboard";
import PartnerOnboarding from "./pages/PartnerOnboarding";
import ManagerLogin from "./pages/ManagerLogin";
import ManagerDashboard from "./pages/ManagerDashboard";
import Install from "./pages/Install";
import useScrollToTop from "./hooks/useScrollToTop";
import { useForceRefresh } from "./hooks/useForceRefresh";
import { AuthProvider } from "./hooks/useAuth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 300000,
      gcTime: 3600000,
      retry: false
    }
  }
});

const RouteChangeHandler = ({ children }: { children: React.ReactNode }) => {
  useScrollToTop();
  useForceRefresh();
  return <>{children}</>;
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <BrowserRouter>
            <Toaster />
            <Sonner />
            <RouteChangeHandler>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/research" element={<Research />} />
                <Route path="/performance" element={<Performance />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/contact" element={<Contact />} />
                {/* Temporarily disabled routes (pages kept for future re-enable):
                    <Route path="/whats-next" element={<WhatsNext />} />
                    <Route path="/trading-philosophy" element={<TradingPhilosophy />} /> */}
                <Route path="/partner-login" element={<PartnerLogin />} />
                <Route path="/partner-request" element={<PartnerRequest />} />
                <Route path="/partner-dashboard" element={<PartnerDashboard />} />
                <Route path="/partner-onboarding" element={<PartnerOnboarding />} />
                <Route path="/manager-login" element={<ManagerLogin />} />
                <Route path="/manager-dashboard" element={<ManagerDashboard />} />
                <Route path="/install" element={<Install />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </RouteChangeHandler>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
